import {
  PriceListDeleteAndReassignRequestType,
  PriceListDeleteAndReassignResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListDeleteAndReassign = (priceListId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceListDeleteAndReassignRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `price-lists/${priceListId}/delete-and-reassign`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PriceListDeleteAndReassignResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers, priceListId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
